import routes from './routes';

const getRoute = (routeName) => {
  if (routes) {
    return routes.filter(route => route.name === routeName)[0];
  }
  return null;
};

export { getRoute };
